import { IconSizes } from "./icon-sizes.type";

export const iconSizes: Record<IconSizes, number> = {
  XXS: 12,
  XS: 16,
  S: 24,
};
